import React from 'react'
import { Link } from 'react-router-dom'
import ruta from '../routes/api-routes'
import axios from 'axios'
import '../styles/TablaCarros.css'

class TablaCarros extends React.Component {

    state = {
        data: [],
        error: ""
    }

    // Call the API endpoint to load data
    async componentDidMount(){
        await this.fetchCarros()     
    }

    // Function to get data from the API
    // Routes were configured in the file named "ruta"
    fetchCarros = async () => {
        try {
            const res = await axios.get(ruta.carros)
            let data = await res.data
            this.setState({
                data,
                error: ""
            })            
        } catch (error) {
            this.setState({
                error: "No se ha encontrado información de la API."
            })
        }
    }

    // Delete an item from the API using an ID
    deleteData = async (id) => {
        try {
            // Asking before delete
            const seguro = window.confirm('¿En realidad quieres eliminar el dato del carro')
            if (seguro) {
                await axios.delete(ruta.borrarCarro + id)
                this.fetchCarros()
            }
        } catch (error) {
            console.log(error)
        }
    }

    render() {

        return (
            <>
                <div className="mt-3 w-75 mx-auto">
                    <h3 className="text-center">{this.state.error}</h3>
                    <table className="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Miniatura</th>
                                <th>Marca</th>
                                <th>Modelo</th>
                                <th>Año</th>
                                <th>Descripción</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.data.map((data, id)=>{
                                return(
                                    <tr key={id}>
                                        <td>{id+1}</td>
                                        <td><img src={data.picturePath} alt="avatar" className="avatar-carro"/></td>
                                        <td>{data.brand}</td>
                                        <td>{data.model}</td>
                                        <td>{data.year}</td>
                                        <td>{data.descrip}</td>
                                        <td className="d-flex justify-content-center">
                                            <button onClick={() => this.deleteData(data._id) } className="btn btn-danger mx-2">Eliminar</button>
                                            <Link to={"/editarCarro/"+data._id} className="btn btn-warning mx-2">Editar</Link>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </>
        )
    }
}

export default TablaCarros